import { COMPANY_CONTACT, COMPANY_NAME } from '../../../settings/constants';

import { Call, Email, FacebookOutlined, Instagram, Menu, WhatsApp } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { HOME_ROUTE } from '../../../routing/routing_constants';
import image from './logo.png';
import './public_header.css';
import { SideBar } from './side_nav_bar';


export const PublicHeader = ({ setOpensidebar, opensidebar}) => {

    const navigate = useNavigate()

    return(
        <div>
            <div style={{height:'2rem', backgroundColor:'gray'}}>
                <div style={{display:'grid', gridTemplateColumns:'0.5fr 3fr',}}>
                    <div>

                    </div>
                    <div style={{display:'flex', flexDirection:'row', justifyContent:'space-evenly'}}  class="fa-3x">
                        <div>
                            <IconButton className='blink_icon' href='https://www.facebook.com/dgatours.travel' target='_blank'>
                                <FacebookOutlined />
                            </IconButton>
                            <small className='hide_in_mini'>DGA tours and travel</small>
                        </div>
                        <div>
                            <IconButton className='blink_icon' href={`https://wa.me/${COMPANY_CONTACT.phones[1]}`} target='_blank'>
                                <WhatsApp />
                                {/* <img alt='facebook_icon' src='' width={'1.5rem'} /> */}
                            </IconButton>
                            <small className='hide_in_mini'>dgatoursBusiness</small>
                        </div>
                        <div>
                            <IconButton className='blink_icon' href='https://www.instagram.com/dga_tours/' target='_blank'>
                                <Instagram />
                                {/* <img alt='instagram_icon' src='' width={'1.5rem'} /> */}
                            </IconButton>
                            <small className='hide_in_mini'>@dga_tours</small>
                        </div>
                        <div>
                            <IconButton className='blink_icon' href={`tel:${COMPANY_CONTACT.phones[0]}`} target='_blank'>
                                <Call />
                                {/* <img alt='call_icon' src='' width={'1.5rem'} /> */}
                            </IconButton>
                            <small className='hide_in_mini'>{COMPANY_CONTACT.phones[0]}/{COMPANY_CONTACT.phones[1]}</small>
                        </div>
                        <div>
                            <IconButton className='blink_icon' href={`mailto:${COMPANY_CONTACT.emails[0]}`} target='_blank'>
                                <Email />
                            </IconButton>
                            <small className='hide_in_mini'>{COMPANY_CONTACT.emails[0]}</small>
                        </div>
                    </div>
                </div>
                <hr />
            </div>
        <div className={`main_container`}>
            <div id='company_name' className='comp_name_short pad_left'>
                            {COMPANY_NAME}
            </div>
            <div className='flexrow main_bg'>
                <div className='logo_section'>
                    <div onClick={e=>navigate(HOME_ROUTE)}>
                        <img src={image} alt="logo" />
                    </div>
                </div>
                <div className={`header_body padding_top flex_column`} >
                    <div className='flexrow hide_on_scroll'>
                        <div className='bolden'>
                            <div>
                            </div>
                            <div className={`side_bar_button`} >
                                <IconButton id='side_bar_button'onClick={e=>setOpensidebar(!opensidebar)}>
                                    <Menu />
                                </IconButton>
                            </div>
                        </div>
                        <div id='company_name' className='comp_name_top'>
                            {COMPANY_NAME}
                        </div>
                            <div className='flex_column'> 
                                {/* <Typography variant='subtitle2'>{'Email:'+ COMPANY_CONTACT.emails[0]}</Typography>
                                <Typography variant='subtitle2'>{'CALL: ' + COMPANY_CONTACT.phones[0]}</Typography> */}
                            </div>
                    </div>
                    <div className={`extra_nav_bar ${!opensidebar && 'hide_extra_nav_bar'}`}>
                        <SideBar setOpensidebar={setOpensidebar} /> 
                    </div>
                </div>
            </div>
            <div>
            </div>
        </div>
        </div>
    )
}